<div class="flex flex-col items-center px-4 ">
  <div class="w-full max-w-2xl mt-6 mb-5">
    <h3 class="mb-6 text-xl font-bold">Status Płatności</h3>
    <div class="text-center">
      <div class="text-gray-700">
        Oczekiwanie na zaksięgowanie wpłaty.<br />
        Może to potrwać do kilku minut.
      </div>
      <div class="flex justify-center py-16">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="flex justify-center">
      <button (click)="startPaymentAgain()" class="btn" color="primary" mat-flat-button>
        ROZPOCZNIJ PONOWNIE
      </button>
    </div>
  </div>
</div>
